export default "__VITE_ASSET__CuR1_v7___"